<div class="rewards-card">
    <ds-modal class="ds-modal" [inverse]="true">
        <ds-modal-header variant="surface" class="ds-modal-header">
            <div slot="center">
                <ds-modal-header-drag slot="start" class="ds-modal-header-drag" />
                <div slot="title">{{ data.title }}</div>
            </div>
        </ds-modal-header>
        <ds-divider vertical="false" [inverse]="false" variant="surface" />
        <ds-modal-content class="ds-modal-content">
            <div class="rewards-card__details">
                <div class="rewards-card__img" [ngStyle]="{ 'background-image': 'url(' + data.tierCardImage + ')' }">
                    <div class="d-flex justify-content-between">
                        <div class="rewards-card__logo" [ngStyle]="{ 'background-image': 'url(' + data.logo + ')' }"></div>
                        @if (data.tierInfo) {
                            <div
                                class="rewards-card__tierInfo font-weight-bold"
                                [vnDynamicHtml]="data.tierInfo"
                                [ngStyle]="{ color: tierInfoColor }"></div>
                        }
                    </div>
                    @if (data.mLifeID) {
                        <div
                            class="rewards-card__mLifeId font-weight-medium"
                            [vnDynamicHtml]="data.mLifeID"
                            [ngStyle]="{ color: tierInfoColor }"></div>
                    }
                    @if (data.userName) {
                        <div class="rewards-card__userName" [ngStyle]="{ color: tierInfoColor }">
                            {{ data.userName | titlecase }}
                        </div>
                    }
                </div>
                <p class="pt-3 rewards-card__description font-weight-normal" [vnDynamicHtml]="data.desrciption"></p>
                <button
                    ds-button
                    variant="filled"
                    kind="tertiary"
                    size="large"
                    inverse="false"
                    data-testid="viewCardCloseButton"
                    class="rewards-card__done_button"
                    (click)="close()">
                    {{ data?.closeButton }}
                </button>
            </div>
        </ds-modal-content>
    </ds-modal>
</div>
